import { useCallback, useState } from "react";
import type { CallBackProps } from "react-joyride";
import { ACTIONS, EVENTS, STATUS } from "react-joyride";

export function useCategoryFormTour() {
  const [run, setRun] = useState(false);

  const startTour = useCallback(() => {
    setRun(true);
  }, []);

  const handleJoyrideCallback = useCallback((data: CallBackProps) => {
    const { status, type, action } = data;
    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
    }

    // Stop tour on close or skip
    if (
      type === EVENTS.STEP_AFTER &&
      (action === ACTIONS.CLOSE || action === ACTIONS.SKIP)
    ) {
      setRun(false);
    }
  }, []);

  return { run, startTour, handleJoyrideCallback };
}
